import { PARTNER_TYPES } from '../../partner-types';
import { MenuItem } from '../types';

export const troubleshootingSection: MenuItem[] = [
  {
    headTitle1: 'Troubleshooting',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL, PARTNER_TYPES.API_PARTNER],
  },
  {
    title: 'Troubleshooting',
    icon: 'stroke-search',
    iconf: 'fill-search',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL, PARTNER_TYPES.API_PARTNER],
    children: [
      {
        path: '/troubleshooting/order-details',
        title: 'Order Investigation',
        type: 'link',
        active: false,
      },
      {
        path: '/troubleshooting/account-activities',
        title: 'Account Activities',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/troubleshooting/account-activity-timeline',
        title: 'Account Activity Timeline',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
    ],
  },
  {
    title: 'POIs / Shops',
    icon: 'stroke-station-management',
    iconf: 'fill-station-management',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL, PARTNER_TYPES.API_PARTNER],
    children: [
      {
        path: '/troubleshooting/pois-and-shops/search',
        title: 'Search POIs / Shops',
        type: 'link',
        active: false,
      },
      {
        path: '/troubleshooting/pois-and-shops/shop-details',
        title: 'Shop Details',
        type: 'link',
        active: false,
      },
      {
        path: '/troubleshooting/pois-and-shops/station-status',
        title: 'Online / Offline Status',
        type: 'link',
        active: false,
      },
      {
        path: '/troubleshooting/pois-and-shops/price-updates',
        title: 'Price Updates',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
    ],
  },
];
